import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import BasePane from '@totem/components/BasePane';
import EmployeeUtilizationContainer from '@totem/components/ticketing/employeeUtilization/employeeUtilizationContainer';
import EmployeeUtilizationFilters from '@totem/components/ticketing/employeeUtilization/employeeUtilizationFilters';
import EmployeeUtilizationTable from '@totem/components/ticketing/employeeUtilization/employeeUtilizationTable';
import TimeEntryReport from '@totem/components/ticketing/employeeUtilization/timeEntryReport';
import CardBody from '@totem/components/ui_components/cards/CardBody';
import CardHeader from '@totem/components/ui_components/cards/CardHeader';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import PrimaryContentPane from '@totem/components/ui_components/page/PrimaryContentPane';

const EmployeeUtilizationDetailsPage = () => {
  const [searchParams] = useSearchParams();
  const { email } = useParams();

  const start = searchParams.get('start');
  const end = searchParams.get('end');

  return (
    <ContentLayout>
      <BasePane>
        <PrimaryContentPane>
          <CardHeader>
            <div>Utilization: {email}</div>
          </CardHeader>
          <CardBody>
            <EmployeeUtilizationContainer
              startTime={start}
              endTime={end}
              employees={[email]}
            >
              <EmployeeUtilizationFilters /> <EmployeeUtilizationTable />
              <br />
              <br />
              <TimeEntryReport employee={email} />
            </EmployeeUtilizationContainer>
          </CardBody>
        </PrimaryContentPane>
      </BasePane>
    </ContentLayout>
  );
};

export default EmployeeUtilizationDetailsPage;
